import React from 'react';
import {makeStyles, useTheme} from '@material-ui/core/styles';
import {useMediaQuery, Grid} from '@material-ui/core';
import propTypes from 'helpers/propTypes';

const isHeader = node => node.props.originalType === 'h1';

const splitChildren = children => {
  if (Array.isArray(children) && isHeader(children[0])) {
    const [title, ...body] = children;
    return [title, body];
  }
  return [null, children];
};

const useStyles = makeStyles(theme => ({
  readingTime: {
    position: 'relative',
    top: hasTitle => (hasTitle ? theme.spacing(-4) : 0),
  },
}));

const TextContent = ({page, children}) => {
  const theme = useTheme();
  const isMd = useMediaQuery(theme.breakpoints.up('md'), {
    defaultMatches: true,
  });

  const [title, body] = splitChildren(children);
  const classes = useStyles(!!title);

  return (
    <Grid container spacing={isMd ? 8 : 4}>
      <Grid item>
        <div>
          {title}
          {page.technicalTimeToRead ? (
            <span className={classes.readingTime}>
              Reading time: {page.technicalTimeToRead} minutes
            </span>
          ) : null}
        </div>
        {body}
      </Grid>
    </Grid>
  );
};

TextContent.propTypes = {
  page: propTypes.page.isRequired,
};

export default TextContent;
